import { render, staticRenderFns } from "./Modifiers.vue?vue&type=template&id=10f4fb08&scoped=true&"
import script from "./Modifiers.vue?vue&type=script&lang=js&"
export * from "./Modifiers.vue?vue&type=script&lang=js&"
import style0 from "./Modifiers.vue?vue&type=style&index=0&id=10f4fb08&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f4fb08",
  null
  
)

export default component.exports